import moment from 'moment';
const dateUtil = function () {
    return {
        fmt: function (input, fmtstring) {
            if(input == '' || input == null){
                return '';
            }
            input = input + '';
            input = input.length < 13 ? Number(input + '000') : input;

            /*小于一周，使用相对时间显示*/
            var now = new Date();
            if (input + 1000 * 60 * 60 * 24 * 7 >= now.getTime()) {
                return moment(input).fromNow();
            } else {
                return moment(input).format(fmtstring);
            }
        },
    }
}();

export default dateUtil;